import type { TrendItemContentTweetsItemAuthorBasicInfo } from './trendItemContentTweetsItemAuthorBasicInfo';
import type { TrendItemContentTweetsItemAuthorSocial } from './trendItemContentTweetsItemAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type TrendItemContentTweetsItemAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: TrendItemContentTweetsItemAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: TrendItemContentTweetsItemAuthorSocial;
};
